<template>
    <div class="flex -mx-2">
        <div class="w-1/3 px-2 hidden xl:block">
            <h3 class="text-md font-semibold">Password</h3>
            <div
                class="mt-2 text-sm text-gray-800"
            >Ensure your account is using a long, random password to stay secure.</div>
        </div>

        <transition name="fade" mode="out-in">
            <div class="w-full px-2 xl:w-2/3" v-if="resource.ready">
                <div class="card">
                    <div class="card-title">Настройки</div>

                    <form class="spaced-y-4" @submit.prevent="submit">
                        <p class="text-gray-800 font-medium mb-2">Данные профиля</p>

                        <div class="flex -mx-2">
                            <text-field
                                class="w-1/2 px-2"
                                title="Имя"
                                v-model="entry.first_name"
                                :errors="errors.first_name"
                                required
                            />

                            <text-field
                                class="w-1/2 px-2"
                                title="Фамилия"
                                v-model="entry.last_name"
                                :errors="errors.last_name"
                                required
                            />
                        </div>

                        <div class="flex -mx-2">
                            <text-field
                                class="w-1/2 px-2"
                                title="Email"
                                v-model="entry.email"
                                :errors="errors.email"
                                type="email"
                                required
                            />

                            <text-field
                                class="w-1/2 px-2"
                                title="Номер телефона"
                                v-model="entry.phone"
                                :errors="errors.phone"
                            />
                        </div>

                        <div class="flex -mx-2">
                            <text-field
                                class="w-1/2 px-2"
                                title="Пароль"
                                v-model="entry.password"
                                :errors="errors.password"
                                type="password"
                            />

                            <text-field
                                class="w-1/2 px-2"
                                title="Подтверждение пароля"
                                v-show="entry.password"
                                v-model="entry.password_confirmation"
                                type="password"
                            />
                        </div>

                        <hr class="mb-4" />

                        <p class="text-gray-800 font-medium mb-2">Параметры</p>

                        <select-field
                            title="Часовой пояс"
                            valueName="value"
                            :options="timezones"
                            :clearable="false"
                            v-model="entry.settings.timezone"
                            :errors="errors['settings.timezone']"
                        ></select-field>

                        <hr class="mb-4" />

                        <p class="text-gray-800 font-medium mb-2">Уведомления</p>

                        <label class="flex mb-3">
                            <input
                                type="checkbox"
                                class="form-checkbox mt-1"
                                v-model="entry.settings.notifications.email"
                            />

                            <div class="ml-2">
                                <div
                                    class="text-gray-800 text-gray-700 text-sm tracking-wider"
                                >Email</div>

                                <div
                                    class="text-sm text-gray-600"
                                >Получать уведомления на почтовый ящик</div>
                            </div>
                        </label>

                        <hr class="mb-3" />

                        <button class="btn btn-primary">Сохранить</button>
                    </form>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import timezones from "@/static/timezones.json";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "users",
                endpoint: "profile",
                routes: {
                    show: "profile",
                    update: "profile"
                }
            },

            timezones: timezones.map(timezone => {
                return {
                    label: timezone.text,
                    value: timezone.utc[0]
                };
            })
        };
    },

    methods: {
        /*
            onFetch () {

            },
            onStore () {

            },
            onUpdate () {

            },
            onDestroy () {

            },
            */
    }
};
</script>